<template>
    <div>
        <div class="bg-blue-600 text-gray-100 tracking-wide font-thin flex w-full justify-between p-2">
            <span><strong>{{ harp.nome }}</strong></span>
            <span>({{ harp.cod_articolo }})</span>
        </div>
        <div class="p-2 bg-blue-500 text-gray-100 tracking-wide">
            {{trans.get('harps.elenco_cordiere')}}
        </div>
        <div class="p-2">
            <ul>
                <li class="flex justify-between my-2 rounded shadow-inner bg-gray-200"
                    v-for="layout in harp.strings_layouts">
                    <div class="p-2">
                        <a :href="'/strings-layouts/' + layout.id">
                            <strong>{{ layout.string_layout_type_description }}</strong>
                        </a>
                    </div>
                    <div class="flex justify-between flex-col">
                        <div class="p-2 mb-2">
                            <strong>{{trans.get('strings.revisione')}}</strong>: {{ layout.revisione }}
                            <!-- Disabilitato incompatibile moments.js con Chrome -->
                            <!-- {{trans.get('harps.rilasciata')}} {{ layout.updated_at | ago}} -->
                        </div>
                        <div class="p-2" v-if="layout.validity_date">
                            <strong>{{trans.get('strings.data_v')}}</strong>: {{ layout.validity_date | human }}
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>

    import moment from 'moment';

    export default {
        props: ['dataset'],

        data() {
            return {
                harp: this.dataset,
            }
        },

        filters: {
            uppercase: (value) => {
                return value.toUpperCase();
            },

            ago: (value) => {
                moment.locale('it');
                return moment(value + 'Z').fromNow();
            },

            human: (value) => {
                if (value != null) {
                    return moment(value).format('DD-MM-YYYY');
                }
            }
        }
    }
</script>